import React from 'react';
import styled from 'styled-components';

import colors from 'utils/colors';

import { BreadCrumbOption } from '../interfaces';

export type ComponentProps = BreadCrumbOption & {
  /**
   * Does the button is last in the list
   */
  isLastItem: boolean;
};

const Text = styled.div`
  position: relative;
`;

const Link = styled.a`
  position: relative;
  background: transparent;
  border: none;
  outline-color: ${colors.orange};
  padding: 0;
  padding-top: 2px;
  padding-bottom: 0px;
  padding-left: 7px;
  padding-right: 7px;
  color: ${colors.blueGrey};
  font-weight: normal;
  transition: color 0.15s ease-in-out;

  :hover,
  :focus {
    color: ${colors.brown};
  }
`;

/**
 * This is the navigation of the different items in the breadcrumb toolbar
 */
const Button: React.FC<ComponentProps> = ({ text, link, isLastItem, enableLink }) => {
  return !isLastItem || enableLink ? (
    <Link
      href={link}
      aria-hidden='false'
      style={{ textDecoration: 'underline', cursor: 'pointer' }}>
      <Text>{text}</Text>
    </Link>
  ) : (
    <Link>
      <Text>{text}</Text>
    </Link>
  );
};

export default Button;
